import $ from 'jquery';

class Search {
    constructor() {
        $(document).ready(() => {
            this.$searchOpen = $('.c-search__switch--active');
            this.$searchClose = $('.c-search__switch--close');
            this.$containerSearchForm = $('.c-search__form ');
            this.$eventClose = $('.c-search__close');
            this.$eventOpen = $('.c-search__open');
            this.$containSearchIcon = $('.c-search__search-icon');
            this.switchLisener();
        });
    }

    switchLisener() {
        this.$eventClose.click(e => {
            this.$containerSearchForm.addClass(' c-search__switch--close');
            this.$containSearchIcon.addClass(' c-search__switch--active');
            this.$containSearchIcon.removeClass(' c-search__switch--close');
        });

        this.$eventOpen.click(e => {
            this.$containSearchIcon.removeClass(' c-search__switch--active');
            this.$containerSearchForm.removeClass(' c-search__switch--close');
            this.$containSearchIcon.addClass(' c-search__switch--close');
        });
    }
}

export default Search;